import './index.scss';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import lightMark from '@/assets/storage/HeaderBlack.svg';
import darkMark from '@/assets/storage/HeaderWhite.svg';
import lightLogo from '@/assets/storage/LogoBlack.svg';
import darkLogo from '@/assets/storage/LogoWhite.svg';
import type { RootState } from '@/store/store';

export const BrandLogo = () => {
  const { t } = useTranslation('common');
  const isDark = useSelector((state: RootState) => state.theme.themeMode) === 'dark';
  const logoSource = isDark ? darkLogo : lightLogo;
  const markSource = isDark ? darkMark : lightMark;

  return (
    <Link to="/" className="c-brand-logo" aria-label={t('common.brand_home_link')}>
      <span className="c-brand-logo__base" aria-hidden="true">
        <img src={markSource} alt="" className="c-brand-logo__mark" />
        <span className="c-brand-logo__divider" aria-hidden="true" />
        <span className="c-brand-logo__name">KEYVOD</span>
      </span>
      <img src={logoSource} alt="" aria-hidden="true" className="c-brand-logo__full" />
    </Link>
  );
};
